import PDFJS from "pdfjs-dist";

// PDFJS を使用し、PDF を png に変換する
export async function convertPdf(
  arrayBuffer: ArrayBufferLike,
  canvasElement: any
): Promise<string> {
  const pdf = await PDFJS.getDocument({
    data: arrayBuffer,
    cMapUrl: "/cmaps/",
    cMapPacked: true
  });
  // 1ページ目をcanvasにレンダリング
  const page = await pdf.getPage(1);
  const canvas = canvasElement;
  const viewport = page.getViewport({ scale: 1 });
  canvas.height = viewport.height;
  canvas.width = viewport.width;
  const context = canvas.getContext("2d");
  const task = page.render({
    canvasContext: context,
    viewport: viewport
  });
  await task.promise;

  return canvas.toDataURL("image/png");
}
